import { Box, Button } from '@mui/material';
import { Link } from 'react-router-dom';
import { Brand } from '../../interfaces/Brand/Brand';
import { sharedColors } from '../../utils/Style';
import { useThemeColor } from '../../hooks/useThemeColor';

type BrandCardProps = {
  brand: Brand;
};

export const BrandCard = ({ brand }: BrandCardProps) => {
  const { primary } = useThemeColor();

  return (
    <Link to={`/marka/${brand.slug}`} style={{ textDecoration: 'none' }}>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          width: '100%',
          alignItems: 'center',
          height: '100%',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            border: '1px solid #e1e1e1',
            width: '100%',
            height: 120,
            alignItems: 'center',
            cursor: 'pointer',
          }}
        >
          <Box
            component='img'
            src={brand.logo}
            alt={brand.name}
            width={100}
            height='100%'
            sx={{
              objectFit: 'contain',
            }}
          />
        </Box>

        {brand.showLabel && (
          <Button
            sx={{
              color: sharedColors.black,
              textTransform: 'none',
              transition: 'color 0.5s ease',
              fontSize: '18px',
              fontWeight: 600,
              mt: 1,
              p: 0,
              '&:hover': {
                color: primary,
                backgroundColor: 'transparent',
              },
            }}
          >
            {brand.name}
          </Button>
        )}
      </Box>
    </Link>
  );
};
